import React from 'react';
import PropTypes from 'prop-types';
import {
  Paper,
  Box,
  Container,
  Divider,
  FormControl,
  Button,
  Chip,
  Autocomplete as MUIAutocomplete,
  Tabs,
  Tab,
  Stack,
  Typography
} from '@mui/material';
import Grid from "@mui/material/Grid2";
import { DataGrid } from '@mui/x-data-grid';
import api from '../../../services/api';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { pt } from 'yup-locale-pt';
import { Autocomplete, Datas, AprovacoesCheckbox } from '../../../components';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { CSVDownload } from 'react-csv';
import { tagsRel } from './static';
import { removerQuebrasDeLinha } from '../../../utils/removerQuebraDeLinha';

yup.setLocale(pt);

function TabPanel(props) {
  const { children, value, index, key, ...other } = props;

  return (
    <div
      key={key}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}

const meses = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Mai',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez'
];

const calculaTotal = (prefix, row) => {
  const valorCampo = campo =>
    row[prefix + campo] == null ? 0 : row[prefix + campo];

  return (
    valorCampo('BlocEnergia') +
    valorCampo('Confinado') +
    valorCampo('Conducao') +
    valorCampo('Produtos') +
    valorCampo('Altura') +
    valorCampo('EquipMov') +
    valorCampo('Cargas') +
    valorCampo('Eletric') +
    valorCampo('Agua') +
    valorCampo('Explosivos') +
    valorCampo('Incendios') +
    valorCampo('Maquinas') +
    valorCampo('Pressurizados') +
    valorCampo('Outros')
  );
};

const columns = [
  [
    {
      field: 'mes',
      headerName: 'Mês',
      valueGetter: (value) => meses[value - 1],
      type: 'string',
      width: 30,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'hht',
      headerName: 'HHT',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      description:
        'É o número de empregados ativos multiplicado pelo número ' +
        'de horas trabalhadas. Deve-se excluir os empregados ' +
        'afastados e aposentados. '
    },
    {
      field: 'acidComAfast',
      headerName: 'Acidentes com afastamento',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      description:
        'São lesões relacionadas ao trabalho (em atividade ' +
        'controlada) que impossibilitam que o empregado ou contratado ' +
        'estejam presentes no trabalho ou exerçam suas funções de ' +
        'rotina no dia seguinte à data da lesão. Esse indicador deve ' +
        'ser considerado mesmo que a pessoa não esteja escalada para ' +
        'trabalhar.'
    },
    {
      field: 'gravDiasPerd',
      headerName: 'Gravidade: Dias perdidos',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      description:
        'A soma de dias corridos de afastamento do trabalho em ' +
        'virtude de lesão pessoal, excetuados o dia do acidente e ' +
        'o dia de retorno ao trabalho.'
    },
    {
      field: 'gravDiasDebt',
      headerName: 'Gravidade: Dias debitados',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      description:
        'Em caso de fatalidade ou perda de membros, teremos dias ' +
        'debitados como descrito na tabela da NBR 14280.'
    },
    {
      field: 'createdAt',
      headerName: 'Inserido',
      type: 'dateTime',
      valueGetter: value => (value ? new Date(value) : null),
      width: 157,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'updatedAt',
      headerName: 'Atualizado',
      type: 'dateTime',
      valueGetter:  value => (value ? new Date(value) : null),
      width: 157,
      sortable: false,
      disableColumnMenu: true
    }
  ],
  [
    {
      field: 'mes',
      headerName: 'Mês',
      valueGetter: (value) => meses[value - 1],
      type: 'string',
      width: 30,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'fatBlocEnergia',
      headerName: 'Bloqueio e isolamento de energia',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'fatConfinado',
      headerName: 'Trabalho em espaço confinado',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'fatConducao',
      headerName: 'Condução de veículos rodoviários',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'fatProdutos',
      headerName: 'Manuseio de produtos químicos e radiação',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'fatAltura',
      headerName: 'Trabalho em altura',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'fatEquipMov',
      headerName: 'Operação de equipamentos móveis',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'fatCargas',
      headerName: 'Içamento de cargas',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'fatEletric',
      headerName: 'Trabalho com eletricidade',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'fatAgua',
      headerName: 'Trabalho próximo à água',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'fatExplosivos',
      headerName: 'Trabalho com explosivos',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'fatIncendios',
      headerName: 'Prevenção e combate ao incêndio',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'fatMaquinas',
      headerName: 'Proteção de máquinas',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'fatPressurizados',
      headerName: 'Sistemas pressurizados',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'fatOutros',
      headerName: 'Outros',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'total',
      headerName: 'Total',
      type: 'number',
      valueGetter: (value, row) => {
        return calculaTotal('fat', row);
      },
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    }
  ],
  [
    {
      field: 'mes',
      headerName: 'Mês',
      valueGetter: (value) => meses[value - 1],
      type: 'string',
      width: 30,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'acidBlocEnergia',
      headerName: 'Bloqueio e isolamento de energia',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'acidConfinado',
      headerName: 'Trabalho em espaço confinado',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'acidConducao',
      headerName: 'Condução de veículos rodoviários',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'acidProdutos',
      headerName: 'Manuseio de produtos químicos e radiação',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'acidAltura',
      headerName: 'Trabalho em altura',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'acidEquipMov',
      headerName: 'Operação de equipamentos móveis',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'acidCargas',
      headerName: 'Içamento de cargas',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'acidEletric',
      headerName: 'Trabalho com eletricidade',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'acidAgua',
      headerName: 'Trabalho próximo à água',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'acidExplosivos',
      headerName: 'Trabalho com explosivos',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'acidIncendios',
      headerName: 'Prevenção e combate ao incêndio',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'acidMaquinas',
      headerName: 'Proteção de máquinas',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'acidPressurizados',
      headerName: 'Sistemas pressurizados',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'acidOutros',
      headerName: 'Outros',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'total',
      headerName: 'Total',
      type: 'number',
      valueGetter: (value, row) => {
        return calculaTotal('acid', row);
      },
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    }
  ],
  [
    {
      field: 'mes',
      headerName: 'Mês',
      valueGetter: (value) => meses[value - 1],
      type: 'string',
      width: 30,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'altoPotBlocEnergia',
      headerName: 'Bloqueio e isolamento de energia',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'altoPotConfinado',
      headerName: 'Trabalho em espaço confinado',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'altoPotConducao',
      headerName: 'Condução de veículos rodoviários',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'altoPotProdutos',
      headerName: 'Manuseio de produtos químicos e radiação',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'altoPotAltura',
      headerName: 'Trabalho em altura',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'altoPotEquipMov',
      headerName: 'Operação de equipamentos móveis',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'altoPotCargas',
      headerName: 'Içamento de cargas',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'altoPotEletric',
      headerName: 'Trabalho com eletricidade',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'altoPotAgua',
      headerName: 'Trabalho próximo à água',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'altoPotExplosivos',
      headerName: 'Trabalho com explosivos',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'altoPotIncendios',
      headerName: 'Prevenção e combate ao incêndio',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'altoPotMaquinas',
      headerName: 'Proteção de máquinas',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'altoPotPressurizados',
      headerName: 'Sistemas pressurizados',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'altoPotOutros',
      headerName: 'Outros',
      editable: true,
      type: 'number',
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    },
    {
      field: 'total',
      headerName: 'Total',
      type: 'number',
      valueGetter: (value, row) => {
        return calculaTotal('altoPot', row);
      },
      flex: 1,
      sortable: false,
      disableColumnMenu: true
    }
  ]
];

const Tema03a = () => {
  let startLoading = useStoreActions(actions => actions.nav.startLoading);
  let stopLoading = useStoreActions(actions => actions.nav.stopLoading);
  let user = useStoreState(state => state.auth.user);

  const [empresas, setEmpresas] = React.useState([]);
  const [cnaes, setCNAEs] = React.useState([]);
  const [registros, setRegistros] = React.useState([]);
  const [anoSelecionado, setAnoSelecionado] = React.useState(
    new Date().getFullYear()
  );
  const [csvData, setCsvData] = React.useState([]);

  const [open, setOpen] = React.useState(false);
  const [preenchido, setPreenchido] = React.useState({});

  const loadEmpresas = async mount => {
    startLoading();
    try {
      let result = (
        await api.http.get(
          '/empresas/' + (user.roleId == 'admin' ? '?all=1' : '')
        )
      ).data;
      if (mount.isMounted) setEmpresas(result);
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    }
  };

  const loadEmpresaCNAEs = async mount => {
    setValue('cnae', null);
    if (!empresaId) {
      setCNAEs([]);
      return;
    }
    startLoading();
    try {
      let result = (await api.http.get('/empresas/' + empresaId + '/cnaes'))
        .data;
      if (mount.isMounted) setCNAEs(result);
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    }
  };

  const schema = yup
    .object({
      empresa: yup
        .number()
        .positive()
        .nullable()
        .label('Selecione a empresa')
        .required(),
      cnae: yup
        .number()
        .positive()
        .nullable()
        .label('Selecione o CNAE')
        .required()
    })
    .required();

  const useFormRef = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema)
  });

  const { watch, setValue } = useFormRef;

  const empresaId = watch('empresa');
  const cnaeId = watch('cnae');

  const onChangeAno = (event, item) => {
    setAnoSelecionado(item);
  };

  const loadRegistros = async mount => {
    startLoading();
    try {
      let url =
        '03a/registros/empresa/' +
        empresaId +
        '/cnae/' +
        cnaeId +
        '/' +
        anoSelecionado;
      let getRegistros = (await api.http.get(url)).data;
      let newRegistros = [];
      let currReg = 0;
      for (let mes = 0; mes < 12; mes++) {
        if (
          getRegistros.length > currReg &&
          getRegistros[currReg].mes == mes + 1
        ) {
          newRegistros.push(getRegistros[currReg++]);
        } else {
          newRegistros.push({
            ano: anoSelecionado,
            mes: mes + 1,
            empresaId: empresaId,
            cnaeId: cnaeId
          });
        }
      }
      if (!mount || mount.isMounted) setRegistros(newRegistros);
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    }
  };

  const processRowUpdate = React.useCallback(async (newRow, oldRow) => {
    startLoading();
    try {
      let result;
      if (newRow.id) {
        result = (
          await api.http.put(
            '03a/registros/empresa/' + newRow.empresaId + '/' + newRow.id,
            newRow
          )
        ).data;
      } else {
        result = (
          await api.http.post(
            '03a/registros/empresa/' +
              oldRow.empresaId +
              '/cnae/' +
              oldRow.cnaeId +
              '/' +
              oldRow.ano,
            newRow
          )
        ).data;
      }
      setReloadOnTabChange(true);
      stopLoading();
      return result;
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
      return oldRow;
    }
  }, []);

  const loadPreenchido = async () => {
    startLoading();
    try {
      let result = (
        await api.http.get(
          `03a/registros-preenchidos/empresa/${empresaId}/cnae/${cnaeId}/${anoSelecionado}`
        )
      ).data;
      const preenchidoZero = result.some(obj => obj.preenchido === 0);
      setPreenchido(preenchidoZero);
      if (result.length == 0) {
        setPreenchido(null);
      }
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    }
  };

  // abre o dialogo de finalizar e salvar
  const handleClickOpen = () => {
    loadPreenchido();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    let mount = {
      isMounted: true
    };
    loadEmpresas(mount);
    return () => {
      mount.isMounted = false;
    };
  }, []);

  React.useEffect(() => {
    let mount = {
      isMounted: true
    };
    loadEmpresaCNAEs(mount);
    return () => {
      mount.isMounted = false;
    };
  }, [empresaId]);

  React.useEffect(() => {
    if (!empresaId || !cnaeId) return;
    let mount = {
      isMounted: true
    };
    loadRegistros(mount);
    return () => {
      mount.isMounted = false;
    };
  }, [empresaId, cnaeId, anoSelecionado]);

  const [reloadOnTabChange, setReloadOnTabChange] = React.useState(false);
  const [tab, setTab] = React.useState(0);

  const handleTabChange = async (event, newValue) => {
    if (reloadOnTabChange) {
      await loadRegistros();
      setReloadOnTabChange(false);
    }
    setTab(newValue);
  };
  function extrairDataHora(dateTimeStr) {
    const dateObj = new Date(dateTimeStr);
    const year = dateObj.getFullYear().toString();
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
    const day = dateObj.getDate().toString().padStart(2, '0');
    const date = `${day}-${month}-${year}`;
    const hours = dateObj.getHours().toString().padStart(2, '0');
    const minutes = dateObj.getMinutes().toString().padStart(2, '0');
    const seconds = dateObj.getSeconds().toString().padStart(2, '0');
    const time = `${hours}:${minutes}:${seconds}`;
    return date + ' ' + time;
  }
  const exportDados = async () => {
    startLoading();
    try {
      const dados = (await api.http.get('/03a/registros')).data;
      const dadosCsv = dados.map(data => {
        return {
          //Saúde e Segurança
          cnpj: data?.empresa?.cnpj,
          empresa: removerQuebrasDeLinha(data.empresa.nome),
          ano: data.ano,
          mes: meses[data?.mes - 1],
          cnae: `${data?.cnae?.codigo} - ${data?.cnae?.descr}`,
          hht: data?.hht,
          acidComAfast: data?.acidComAfast,
          gravDiasPerd: data?.gravDiasPerd,
          gravDiasDebt: data?.gravDiasDebt,
          //Fatalidades
          fatBlocEnergia: data?.fatBlocEnergia,
          fatConfinado: data?.fatConfinado,
          fatConducao: data?.fatConducao,
          fatProdutos: data?.fatProdutos,
          fatAltura: data?.fatAltura,
          fatEquipMov: data?.fatEquipMov,
          fatCargas: data?.fatCargas,
          fatEletric: data?.fatEletric,
          fatAgua: data?.fatAgua,
          fatExplosivos: data?.fatExplosivos,
          fatIncendios: data?.fatIncendios,
          fatMaquinas: data?.fatMaquinas,
          fatPressurizados: data?.fatPressurizados,
          fatOutros: data?.fatOutros,
          fatTotal: Number(
            data?.fatBlocEnergia +
              data?.fatConfinado +
              data?.fatConducao +
              data?.fatProdutos +
              data?.fatAltura +
              data?.fatEquipMov +
              data?.fatCargas +
              data?.fatEletric +
              data?.fatAgua +
              data?.fatExplosivos +
              data?.fatIncendios +
              data?.fatMaquinas +
              data?.fatPressurizados +
              data?.fatOutros
          ),
          //Total de Acidentes
          acidBlocEnergia: data?.acidBlocEnergia,
          acidConfinado: data?.acidConfinado,
          acidConducao: data?.acidConducao,
          acidProdutos: data?.acidProdutos,
          acidAltura: data?.acidAltura,
          acidEquipMov: data?.acidEquipMov,
          acidCargas: data?.acidCargas,
          acidEletric: data?.acidEletric,
          acidAgua: data?.acidAgua,
          acidExplosivos: data?.acidExplosivos,
          acidIncendios: data?.acidIncendios,
          acidMaquinas: data?.acidMaquinas,
          acidPressurizados: data?.acidPressurizados,
          acidOutros: data?.acidOutros,
          acidTotal: Number(
            data?.acidBlocEnergia +
              data?.acidConfinado +
              data?.acidConducao +
              data?.acidProdutos +
              data?.acidAltura +
              data?.acidEquipMov +
              data?.acidCargas +
              data?.acidEletric +
              data?.acidAgua +
              data?.acidExplosivos +
              data?.acidIncendios +
              data?.acidMaquinas +
              data?.acidPressurizados +
              data?.acidOutros
          ),
          //Incidentes de alto potencial
          altoPotBlocEnergia: data?.altoPotBlocEnergia,
          altoPotConfinado: data?.altoPotConfinado,
          altoPotConducao: data?.altoPotConducao,
          altoPotProdutos: data?.altoPotProdutos,
          altoPotAltura: data?.altoPotAltura,
          altoPotEquipMov: data?.altoPotEquipMov,
          altoPotCargas: data?.altoPotCargas,
          altoPotEletric: data?.altoPotEletric,
          altoPotAgua: data?.altoPotAgua,
          altoPotExplosivos: data?.altoPotExplosivos,
          altoPotIncendios: data?.altoPotIncendios,
          altoPotMaquinas: data?.altoPotMaquinas,
          altoPotPressurizados: data?.altoPotPressurizados,
          altoPotOutros: data?.altoPotOutros,
          altoPotTotal: Number(
            data?.altoPotBlocEnergia +
              data?.altoPotConfinado +
              data?.altoPotConducao +
              data?.altoPotProdutos +
              data?.altoPotAltura +
              data?.altoPotEquipMov +
              data?.altoPotCargas +
              data?.altoPotEletric +
              data?.altoPotAgua +
              data?.altoPotExplosivos +
              data?.altoPotIncendios +
              data?.altoPotMaquinas +
              data?.altoPotPressurizados +
              data?.altoPotOutros
          ),

          createdAt: data.createdAt ? extrairDataHora(data.createdAt) : null,
          updatedAt: data.updatedAt ? extrairDataHora(data.updatedAt) : null
        };
      });

      if (dadosCsv.length == 0) {
        stopLoading({
          message: 'Nenhum registro encontrado.',
          severity: 'error'
        });
      } else {
        setCsvData([tagsRel, ...dadosCsv]);
        stopLoading();
      }
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    }
  };

  return (
    (<div>
      {/* <Box className="header">
         </Box> */}
      <Container maxWidth="false">
        <Paper
          variant="outlined"
          className="center-box"
          sx={{
            textAlign: 'center',
            px: 4,
            pt: 2,
            pb: 3,
            m: 5
          }}
        >
        <Grid m={3}>
            <Typography>
              <h3>O preenchimento do GT 3 deve ser feito diretamente na plataforma:</h3>
              <br></br>
              <a
                href="http://bit.ly/ibramsso"
                target="_blank"
                style={{
                  fontWeight: 'bold',
                  color: '#004071',
                  marginLeft: 5
                }}
                rel="noreferrer"
              >
                Preenchimento ESG da Mineração - GT 03a e 03b
              </a>
              <br></br>
              Período de referência: as empresas devem ter atualizado os dados até o 1º semestre/2025
              <br></br>
              Prazo para preenchimento: até 15 de agosto de 2025
            </Typography>
          </Grid>
        </Paper>
      </Container>
    </div>)
  );
};

export default Tema03a;
